import { useState } from "react";
import dayjs from "dayjs";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { Eye, X } from "react-feather";
import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import { toFixed2, toNumber } from "../components/exportUtils";
import ContainerReportDetails from "./ContainerReportDetails";

const formatDate = (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-");

const ContainerReports = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Container Reports", websiteData);

    const report = useServerReport("report/container-report");
    const [selectedContainer, setSelectedContainer] = useState(null);

    const columns = [
        { key: "reference_id", label: "Shipping Id" },
        { key: "container_no", label: "Container Id", primary: true },
        { key: "shipping_date", label: "Shipping Date", render: (row) => formatDate(row?.shipping_date), exportValue: (row) => formatDate(row?.shipping_date) },
        { key: "arrival_date", label: "Arrival Date", render: (row) => formatDate(row?.arrival_date), exportValue: (row) => formatDate(row?.arrival_date) },
        { key: "eta_of_container", label: "ETA", render: (row) => formatDate(row?.eta_of_container), exportValue: (row) => formatDate(row?.eta_of_container) },
        { key: "no_of_bookings", label: "No Of Bookings", align: "right" },
        { key: "total_booking_amount", label: "Total Booking Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total_booking_amount)), exportValue: (row) => toFixed2(row?.total_booking_amount) },
        {
            key: "actions", label: "", align: "right", noExport: true, render: (row) => (<Tooltip title="View bookings">
                <Button className={`${styles.TableActionBU}`} onClick={() => setSelectedContainer(row)} aria-label="View container bookings"><Eye /></Button>
            </Tooltip>)
        },
    ];

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Container Reports" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Container Report" filename="container-report" searchPlaceholder="Search by shipping or container id" />
            <ReportTable report={report} columns={columns} minWidth={900} />
        </div>

        <Dialog
            fullWidth
            maxWidth="lg"
            className={`${styles.NewPopUp}`}
            open={selectedContainer !== null}
            onClose={() => setSelectedContainer(null)}
        >
            <DialogTitle className={`${styles.PopupTitleBar}`}>
                Container Details: #{selectedContainer?.container_no}
                <IconButton className={`${styles.PopupCloseBU}`} onClick={() => setSelectedContainer(null)} aria-label="Close"><X /></IconButton>
            </DialogTitle>
            <DialogContent className={`${styles.PopupContent}`}>
                {selectedContainer && <ContainerReportDetails containerId={selectedContainer.id} />}
            </DialogContent>
        </Dialog>
    </div>);
};

export default withAdminAuth(ContainerReports);
